import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldCropsGridComponent } from './field-crops-grid.component';
import { DxDataGridModule, DxPopoverModule, DxSwitchModule } from 'devextreme-angular';
import { GridDefaultModule, GridTitleModule } from 'shared';
import { CropSelectorModule } from '../../crops/crop-selector/crop-selector.module';
import { CampaignSelectorModule } from '../../campaign/campaign-selector/campaign-selector.module';



@NgModule({
  declarations: [FieldCropsGridComponent],
  imports: [
    CommonModule,
    DxDataGridModule,
    GridDefaultModule,
    GridTitleModule,
    DxSwitchModule,
    CropSelectorModule,
    CampaignSelectorModule,
    DxPopoverModule
  ],
  exports: [FieldCropsGridComponent]
})
export class FieldCropsGridModule { }
